module.exports = __webpack_public_path__ + "static/media/59.ef26d8d9.jpg";